var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1532_4184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.4178 8 12.871 8.46919 11.5554 9.34824C10.2398 10.2273 9.21447 11.4767 8.60897 12.9385C8.00347 14.4003 7.84504 16.0089 8.15372 17.5607C8.4624 19.1126 9.22433 20.538 10.3431 21.6569C11.462 22.7757 12.8874 23.5376 14.4393 23.8463C15.9911 24.155 17.5997 23.9965 19.0615 23.391C20.5233 22.7855 21.7727 21.7602 22.6518 20.4446C23.5308 19.129 24 17.5823 24 16C23.9978 13.879 23.1542 11.8454 21.6544 10.3456C20.1546 8.84581 18.121 8.00224 16 8ZM19.5123 16.4354L17.0508 18.8969C16.9353 19.0124 16.7787 19.0773 16.6154 19.0773C16.4521 19.0773 16.2955 19.0124 16.18 18.8969C16.0645 18.7815 15.9997 18.6248 15.9997 18.4615C15.9997 18.2982 16.0645 18.1416 16.18 18.0262L17.5915 16.6154H12.9231C12.7599 16.6154 12.6033 16.5506 12.4879 16.4351C12.3725 16.3197 12.3077 16.1632 12.3077 16C12.3077 15.8368 12.3725 15.6803 12.4879 15.5649C12.6033 15.4495 12.7599 15.3846 12.9231 15.3846H17.5915L16.18 13.9738C16.0645 13.8584 15.9997 13.7018 15.9997 13.5385C15.9997 13.3752 16.0645 13.2185 16.18 13.1031C16.2955 12.9876 16.4521 12.9227 16.6154 12.9227C16.7787 12.9227 16.9353 12.9876 17.0508 13.1031L19.5123 15.5646C19.5695 15.6218 19.6149 15.6896 19.6459 15.7643C19.6769 15.8391 19.6928 15.9191 19.6928 16C19.6928 16.0809 19.6769 16.1609 19.6459 16.2357C19.6149 16.3104 19.5695 16.3782 19.5123 16.4354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1532_4184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/ArrowCircleRight.809540d4c1893978c5232b9391b0a52d.svg";
export { ForwardRef as ReactComponent };